import React, { ChangeEvent, FormEvent, useCallback, useEffect, useState } from 'react';
import { noInfosLabel } from '../../utils/no-infos-label';
import {
  Button,
  Input,
  makeStyles,
  Textarea,
} from '@fluentui/react-components';
import {
  DeleteRegular,
  EditRegular,
  SaveEditRegular,
} from '@fluentui/react-icons';

const useStyles = makeStyles({
  editableWrapperStyle: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1
  },
  textFieldStyle: {
    flex: 1,
  },
  editButtonStyle: {
    marginLeft: '10px',
  },
  saveButtonStyle: {
    flex: 0,
    marginLeft: '2px',
    alignSelf: 'center'
  },
  cancelButtonStyle: {
    flex: 0,
    marginLeft: '2px',
    alignSelf: 'center'
  },
});

export const EditableValue = (props: {
  value?: string;
  editable?: boolean;
  multiline?: boolean;
  editing?: boolean;
  onStartEditing: () => void;
  onSave: (newValue: string) => void;
  onCancel: () => void;
}) => {
  const { value, editable, multiline, editing, onStartEditing, onSave, onCancel } = props;
  const [newValue, setNewValue] = useState(value || '');
  const styles = useStyles();

  useEffect(() => {
    setNewValue(value || '');
  }, [value]);

  const doEdit = useCallback(() => {
    onStartEditing()
  }, [onStartEditing]);

  const doSave = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      onSave(newValue);
    },
    [newValue, onSave]
  );

  const doCancel = useCallback(() => {
    setNewValue(value || '');
    onCancel();
  }, [onCancel, value]);

  const onChange = useCallback(
    (_: ChangeEvent<HTMLElement>, data: {  value: string }) => {
      setNewValue(data.value);
    },
    []
  );

  if (!editing) {
    return (
      <>
        {value || noInfosLabel('...')}
        {editable && (
          <Button
            className={styles.editButtonStyle}
            onClick={doEdit}
            icon={<EditRegular />}
          />
        )}
      </>
    );
  }

  return (
    <form className={styles.editableWrapperStyle} onSubmit={doSave}>
      {multiline ? (
        <Textarea
          className={styles.textFieldStyle}
          value={newValue}
          onChange={onChange}
        />
      ) : (
        <Input
          className={styles.textFieldStyle}
          value={newValue}
          onChange={onChange}
        />
      )}
      <Button
        className={styles.saveButtonStyle}
        onClick={doSave}
        disabled={!newValue}
        icon={<SaveEditRegular />}
      />
      <Button
        className={styles.cancelButtonStyle}
        onClick={doCancel}
        icon={<DeleteRegular />}
      />
    </form>
  );
};
